<template>
  <v-menu
    location="bottom right"
    @update:model-value="state.showSelectionMenu = $event"
    :close-on-content-click="false"
  >
    <template #activator="{ props }">
      <v-icon v-bind="props">mdi-menu-down </v-icon>
    </template>
    <v-list>
      <template v-for="item in items" :key="item.fileName">
        <v-list-item
          active-color="primary"
          :active="item.loading"
          :value="false"
          @click="
            {
              if (!item.loading) download(item);
            }
          "
          >{{ item.title }}
          <v-tooltip activator="parent" location="bottom">{{ item.tooltip }}</v-tooltip>
          <template #append v-if="item.loading">
            <v-progress-circular
              class="ml-4"
              size="small"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </template>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import FetchService from "@/services/fetch.service";
import { useAlertsStore } from "@/stores/alerts";
import downloadFile from "@/utils";
import { reactive } from "vue";
import { ref } from "vue";
import { computed } from "vue";

type FileNames = "enrollment" | "team" | "relationship" | "team_enrollment";
const downloadTypes = ref<
  {
    title: string;
    fileName: FileNames;
    loading: boolean;
    endPoint: string;
    tooltip: string;
  }[]
>([
  {
    title: "Enrollment",
    fileName: "enrollment",
    loading: false,
    endPoint: "/enrollment/download",
    tooltip: "Relations between parent, student and teacher"
  },
  {
    title: "Relationships",
    fileName: "relationship",
    loading: false,
    endPoint: "/relationship/download",
    tooltip: "Relations between parent and student"
  },
  {
    title: "Team Enrollment",
    fileName: "team_enrollment",
    loading: false,
    endPoint: "/team_enrollment/download",
    tooltip: "Relations between parent, student and team"
  },
  
]);
const props = defineProps<{
  downloadTypes: FileNames[];
}>();

const state = reactive({
  showSelectionMenu: false
});

const items = computed(() => {
  return downloadTypes.value.filter((i) => props.downloadTypes.includes(i.fileName));
});

const download = async (item: (typeof downloadTypes.value)[number]) => {
  item.loading = true;
  const res = await FetchService.fetchData(`${item.endPoint}`, "get", undefined, true);
  const cType = res?.res?.headers.get?.("content-type") || "";
  if (typeof res?.data === "string" && cType.includes("text/csv")) {
    downloadFile(
      res.data,
      res?.res?.headers?.get("content-disposition")?.split("filename=")?.[1]?.replace(/"/g, "") ||
        `${item.fileName}.csv`,
      "text/csv"
    );
  } else {
    useAlertsStore().addAlert(
      "error",
      `Failed to download ${item.title}, please try again later`,
      10
    );
  }
  item.loading = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
